import type IndicatorPeriodView from '@UI/Store/Indicators/Views/IndicatorPeriodView';

export type FormattedIndicatorPeriod = {
	readonly from: string;
	readonly to: string;
};

const TIME_ZONE = 'Europe/Paris';

const dayMonthFormat = new Intl.DateTimeFormat('fr-FR', {
	timeZone: TIME_ZONE,
	day: 'numeric',
	month: 'short',
});
const dayMonthYearFormat = new Intl.DateTimeFormat('fr-FR', {
	timeZone: TIME_ZONE,
	day: 'numeric',
	month: 'short',
	year: 'numeric',
});
const yearFormat = new Intl.DateTimeFormat('fr-FR', { timeZone: TIME_ZONE, year: 'numeric' });

/**
 * Bounds of the window as Paris calendar days, never the browser's: "8 sept." to "7 oct. 2026". The
 * start carries its year only when it differs from the end's.
 */
const formatIndicatorPeriod = (period: IndicatorPeriodView): FormattedIndicatorPeriod => {
	const sameYear = yearFormat.format(period.from) === yearFormat.format(period.to);

	return {
		from: (sameYear ? dayMonthFormat : dayMonthYearFormat).format(period.from),
		to: dayMonthYearFormat.format(period.to),
	};
};

export default formatIndicatorPeriod;
